// Import model
import { ObjectAppointmentCondition } from '../models/ObjectAppointmentCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ObjectAppointmentIndexedFields } from '../models/ObjectAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ObjectAppointmentIndexedFieldsSerializer } from './ObjectAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ObjectAppointmentCondition - handles JSON serialization and deserialization with type validation
 */
export class ObjectAppointmentConditionSerializer {
  /**
   * Deserializes a JSON string into a ObjectAppointmentCondition instance
   */
  static deserialize(json: string): ObjectAppointmentCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ObjectAppointmentCondition instance
   */
  static fromObject(obj: any): ObjectAppointmentCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ObjectAppointmentCondition');
    }


    const instance: ObjectAppointmentCondition = {
      fieldName: obj['fieldName'] as ObjectAppointmentIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ObjectAppointmentCondition instances
   */
  static deserializeArray(json: string): ObjectAppointmentCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ObjectAppointmentCondition instance to a JSON string
   */
  static serialize(instance: ObjectAppointmentCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ObjectAppointmentCondition instance to a plain object
   */
  static toObject(instance: ObjectAppointmentCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ObjectAppointmentCondition instances to a JSON string
   */
  static serializeArray(instances: ObjectAppointmentCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
